<template>
  <div class="about-container">
    <div class="about-container__wrapper">
      <div class="item" style="min-height: 10px">
        <span style="font-size: 14px; font-weight: bold; padding-left: 20px" class="primary--text">
          {{ $filters.filterCapitalize($i18n.t("dataFrom")) }} {{ date }}
        </span>
      </div>
    </div>
    <div class="about-container__wrapper">
      <div class="item" style="min-height: 200px">
        <div class="card-container">
          <card-data-comparator v-for="(item, index) in cardComparerData" :key="index" :item="item" />
        </div>
      </div>
    </div>
    <div class="about-container__wrapper last">
      <div class="item" style="min-height: 300px">
        <booking-chart />
      </div>
    </div>
    <v-tooltip top>
      <template #activator="{ attrs, on }">
        <span v-bind="attrs" class="application-version" v-on="on" @click="copyVersion">
          {{ $i18n.t("currentVersion") | capitalize }}
          {{ commitDate | formatDateTimeSeconds }}
        </span>
      </template>
      <span>
        Aktualna wersja: {{ tagName }} {{ tagInProgress }} z dnia {{ commitDate | formatDateTimeSeconds }} <br />
        Szczegóły: {{ branchName }}@{{ commitNumber }}({{ commitCount }}) <br />
      </span>
    </v-tooltip>
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";
import LayoutCenter from "@/components/shared/layout/LayoutCenter.vue";

// Components
import BookingChart from "@/components/statistics/charts/BookingChart.vue";
import CardDataComparator from "@/components/statistics/charts/CardDataComparator.vue";
import { ComparedData } from "@/models/api/statistics/Statistics";
import { filterFormatDateTimeSeconds } from "@/filters/formatDateTimeSeconds";

@Component({
  components: {
    LayoutCenter,
    BookingChart,
    CardDataComparator,
  },
})
export default class AboutView extends Vue {
  get windowTitle(): string {
    return this.$filters.filterCapitalize(this.$i18n.t("mainPage"));
  }
  get cardComparerData(): Array<ComparedData> {
    if (this.$store.direct.state.statistics.dashboardData != null) {
      return this.$store.direct.state.statistics.dashboardData;
    } else return [];
  }
  get commitNumber(): string {
    return process.env.VUE_APP_GIT_SHORT as string;
  }
  get commitCount(): number {
    return process.env.VUE_APP_GIT_COUNT as unknown as number;
  }
  get branchName(): string {
    return process.env.VUE_APP_GIT_BRANCH as string;
  }
  get commitDate(): string {
    return process.env.VUE_APP_GIT_DATE as string;
  }
  get tagName(): string {
    return process.env.VUE_APP_GIT_TAG as string;
  }
  get tagInProgress(): string {
    return process.env.VUE_APP_GIT_TAG_IS_DIRTY ? "development" : "release";
  }
  get date() {
    if (this.cardComparerData.length > 0 && this.cardComparerData[0]?.date != undefined) {
      const currentLocale = this.$i18n.locale;
      const forDate = this.cardComparerData[0].date;
      const formatter = new Intl.DateTimeFormat(currentLocale, {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      return formatter.format(new Date(forDate));
    }
    return "";
  }

  copyVersion() {
    const commitDate = filterFormatDateTimeSeconds(this.commitDate);
    const message = [this.branchName, this.commitNumber, commitDate];
    navigator.clipboard.writeText(message.join(" - "));
  }

  mounted() {
    this.$store.direct.dispatch.statistics.getStatistics();
  }
}
</script>

<style lang="scss" scoped>
.about-container__box {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: calc(100%);
}

.card-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap-reverse;
  flex-grow: 1;
}

.about-container__version {
  position: absolute;
  bottom: 5px;
  left: 5px;
}

.about-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 60px;
  height: calc(100% - 48px);
  min-height: calc(100vh - 48px);
  position: relative;
}

.about-container__wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  gap: 10px;
}

.item {
  width: calc(100%);
  display: flex;
  height: calc(100%);
}

.application-version {
  position: absolute;
  bottom: 5px;
  left: 10px;
}

.about-container .about-container__wrapper.last {
  flex-grow: 20;
}
</style>
